import { useClientId, useCopyPasteStyles, useDeviceType } from "@blocks/hooks";
import { RichText } from "@wordpress/block-editor";
import { Fragment } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { EditProps } from "blocks/types";
import classnames from "classnames";
import { escape } from "lodash";
import React from "react";
import { useBlockStyle } from "../../hooks";

import "../assets/sass/blocks/heading/style.scss";
import InspectorControls from "./components/InspectorControls";

const Edit: React.ComponentType<EditProps<any>> = (props) => {
	const {
		className,
		attributes: {
			enableSubHeading,
			label,
			text,
			cssID,
			markup,
			typography,
			subHeadingTypography,

			headingLayout1AdvancedStyle,
			headingLayout2AdvancedStyle,
			headingLayout3AdvancedStyle,
			headingLayout4AdvancedStyle,
			headingLayout5AdvancedStyle,
			headingLayout6AdvancedStyle,
			headingLayout7AdvancedStyle,
			headingLayout8AdvancedStyle,
			headingLayout9AdvancedStyle,
			headingLayout,

			size,
			hideOnDesktop,
		},
		setAttributes,
	} = props;

	const { clientId } = useClientId(props);
	const { deviceType } = useDeviceType();
	const { CopyPasterStyleBlockControl } = useCopyPasteStyles();
	const { Style } = useBlockStyle({
		blockName: "heading",
		clientId,
		attributes: props.attributes,
		deviceType,
	});

	const classNames = classnames(
		`mzb-heading mzb-heading-${clientId} mzb-${headingLayout}`,
		size && `is-${size}`,
		className,
		hideOnDesktop && "magazine-blocks-hide-on-desktop",
		{
			[`mzb-${headingLayout1AdvancedStyle}`]:
				headingLayout === `heading-layout-1`,
			[`mzb-${headingLayout2AdvancedStyle}`]:
				headingLayout === `heading-layout-2`,
			[`mzb-${headingLayout3AdvancedStyle}`]:
				headingLayout === `heading-layout-3`,
			[`mzb-${headingLayout4AdvancedStyle}`]:
				headingLayout === `heading-layout-4`,
			[`mzb-${headingLayout5AdvancedStyle}`]:
				headingLayout === `heading-layout-5`,
			[`mzb-${headingLayout6AdvancedStyle}`]:
				headingLayout === `heading-layout-6`,
			[`mzb-${headingLayout7AdvancedStyle}`]:
				headingLayout === `heading-layout-7`,
			[`mzb-${headingLayout8AdvancedStyle}`]:
				headingLayout === `heading-layout-8`,
			[`mzb-${headingLayout9AdvancedStyle}`]:
				headingLayout === `heading-layout-9`,
		}
	);

	return (
		<Fragment>
			<InspectorControls
				attributes={props.attributes}
				setAttributes={setAttributes}
			/>
			<CopyPasterStyleBlockControl withBlockControls />
			<Style />
			<div className={classNames}>
				<div className="mzb-heading-inner mzb-post-heading">
					<RichText
						id={cssID ? cssID : null}
						className={`mzb-heading-text ${typography?._className}`}
						tagName={markup}
						placeholder={__("This is heading", "magazine-blocks")}
						value={text}
						onChange={(val) => {
							setAttributes({ text: val });
						}}
					/>
				</div>
				{enableSubHeading && (
					<div className="mzb-sub-heading">
						<RichText
							id={cssID ? cssID : null}
							className={`${subHeadingTypography?._className}`}
							tagName="p"
							value={escape(label)}
							onChange={(val) => {
								setAttributes({ label: val });
							}}
						/>
					</div>
				)}
			</div>
		</Fragment>
	);
};

// @ts-ignore
export default Edit;
